<template>
	<div id="div-subform" class="w-full vs-con-loading__container">
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="9" class="text-left">
				<vs-select autocomplete class="selectExample mt-5 w-full px-2" v-model="idSubForm"  :label="$t('MODULE.subforms.labelSubform')">
				    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in filterList" />
				</vs-select>
			</vs-col>
		</vs-row>
		<MinMax class="mt-4" :index="index" labelMin="subforms.minAnswer" labelMax="subforms.maxAnswer"></MinMax>
	</div>
</template>

<script type="text/javascript">
	import Default from '../../componentsToQuestions/DefaultSelect.vue';
	import MinMax from '../../componentsToQuestions/Min-Max.vue';
	import { mapState, mapActions } from 'vuex';

	export default {
		props: ['index'],
		components: { Default, MinMax },
		props: ['index'],
		methods: {
			...mapActions('resource', ['getOneSubformDetails']),
            /**
             * Obtiene un subformualario y lo vincula al formulario padre.
             * @param {string} id - ID ó KEY del suformulario.
             */
			async AddForm(id) {
				try{
					this.$vs.loading({
				        container: '#div-subform',
				        scale: 0.6
				      })
					const result = await this.getOneSubformDetails(id);
					this.questionsByPage[this.index].inherited = [result]
				} catch(e) {
					console.log(e);
				} finally  {
					this.$vs.loading.close('#div-subform > .con-vs-loading')
				}
			}
		},
		computed: {
			...mapState('resource',['questionsByPage', 'listSubFormularios', 'idForm']),
            filterList() {
                return this.listSubFormularios.filter(form => form.value !== this.idForm)
            },
            /**
             * Obtiene el ID ó KEY del subformulario seleccionado.
             */
			idSubForm: {
				get() {
					if(this.questionsByPage[this.index].inherited) {
						if(this.questionsByPage[this.index].inherited.length > 0) {
							return this.questionsByPage[this.index].inherited[0].formID;
						}
					}
					return '';
				},
				set(value) {
					this.AddForm(value)
				}
			}
		},
        mounted() {
            if(this.questionsByPage[this.index].inherited[0]) {
                if(this.questionsByPage[this.index].inherited[0].formID === this.idForm) {
                    this.questionsByPage[this.index].inherited = []
                }
            }
        }
	}
</script>
